import React from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import { InputNumberMask } from '../../../../../../../../CommonComponents/OPL/Input/InputNumberMask';
import { FormFields } from '../../AccountForm.meta';

export const MonthlyDistributionAmount = () => {
  const { control } = useFormContext<FormFields>();

  return (
    <Controller
      control={control}
      name="bankAccount.MonthlyDistributionAmount"
      render={({ field: { onChange, ...field } }) => (
        <InputNumberMask
          {...field}
          leftIcon="fa fa-dollar-sign"
          allowNegative={false}
          innerText="/month"
          label="Monthly Distribution"
          onValueChange={({ value }) => {
            onChange(value ?? null);
          }}
        />
      )}
    />
  );
};
